<template>
  <template v-if="el.attributes.href?.startsWith('mailto:')">
    <FaIcon icon-class="fal fa-envelope" classes="align-self-center" />
    <a
      class="w-full text-vdv-base"
      :href="getMailHref(el)"
      @click="openMailer(el)"
    >
      <Renderer :json="el.children ?? []" />
    </a>
  </template>
  <template v-else>
    <NuxtLink
      v-if="el.classList.contains('scroll-to-form-enabled')"
      class="cursor-pointer"
      :class="getLinkClasses(el)"
      @click="scrollToForm()"
    >
      <Renderer :json="el.children ?? []" />
    </NuxtLink>
    <NuxtLink
      v-else
      :class="getLinkClasses(el)"
      :to="el.attributes.href"
      :target="el.attributes.target ?? '_self'"
    >
      <Renderer :json="el.children ?? []" />
    </NuxtLink>
  </template>
</template>
<script setup lang="ts">
import type { HTMLElementSimplified } from '@/components/components/cms/wysiwyg/types';
import { linkTo_UnCryptMailto } from '@/helpers/encryptMail';
import FaIcon from '@/components/fa-icon.vue';
import Renderer from '../../renderer/vdv/renderer.vue';
import { scrollToElement } from '@/helpers/scroll';

defineProps({
  el: {
    type: Object as PropType<HTMLElementSimplified>,
    required: true,
    default: () => ({}) as HTMLElementSimplified,
  },
});

function getMailHref(el: HTMLElementSimplified) {
  const mail = el.attributes.href?.substring(7);
  const decryptedMail = linkTo_UnCryptMailto(`mailto:${mail}`, -13);
  return 'javascript:' + decryptedMail;
}

function openMailer(el: HTMLElementSimplified) {
  const mail = el.attributes.href?.substring(7);
  window.location.href = 'mailto:' + mail;
}

function getLinkClasses(el: HTMLElementSimplified) {
  const isMediaLink = el.children?.some(
    (child) => child.tag.toLowerCase() === 'img',
  );
  if (isMediaLink) return 'text-vdv-base';

  return 'text-vdv-base anim__underline-link vdv-anim-link';
}

const scrollToForm = () => {
  const formElements = document.querySelectorAll('form');
  if (formElements.length > 0) {
    const parentSection = formElements[0].parentElement.closest('section');
    const contentBlockSection = parentSection.parentElement.closest('section');
    scrollToElement(contentBlockSection ?? parentSection);
  }
  return;
};
</script>
